import { deepMerge, getTargetOffsetTop } from 'js/utils/Utils' // スクロールTop取得補助
import Common from 'js/_core/Common'

const defaults = {
  instanceName: 'navBusinessHighlighter',
  $names: {
    navItem: '[data-nav-business-item]',
    navSection: '[data-nav-business-sect]',
  },
  classNames: {
    current: 'is-current',
  },
}

export default class NavBusinessHighlighter {
  $contentRoot = document
  $items = []
  $sections = []
  sectionInfo = []
  currentKey = null

  constructor(options = {}) {
    this.$contentRoot = options.root || document

    deepMerge(this, defaults, options)
  }

  init() {
    this._set$()
    this._setInfo()
    this._addHandlers()
  }

  destroy() {
    this._removeHandlers()
  }

  _set$() {
    this.$items = this.$contentRoot.querySelectorAll(this.$names.navItem)
    this.$sections = this.$contentRoot.querySelectorAll(this.$names.navSection)
  }

  _setInfo() {
    this.sectionInfo = Array.from(this.$sections).map(($sect) => {
      const key = $sect.dataset.navBusinessSect
      const $item = this.$contentRoot.querySelector(`[data-nav-business-item="${key}"]`)
      return {
        key,
        $sect,
        $item,
        top: 0,
        bottom: 0,
        height: 0,
      }
    })

    this._updatePos()
  }

  _updatePos() {
    const wh = window.innerHeight

    this.sectionInfo.forEach((info) => {
      const top = getTargetOffsetTop(info.$sect)
      const height = info.$sect.getBoundingClientRect().height
      const bottom = top + height
      const centerLine = wh / 2

      // 中央 or 最下部が見えた時、のどちらか早い方で発火
      // info.top = Math.min(top + centerLine, bottom - wh)
      info.top = Math.min(top - centerLine, bottom - wh)
      info.bottom = bottom
      info.height = height
    })
  }

  _addHandlers() {
    if (Common.raf) {
      Common.raf.addHandler(() => this.onRaf(), 'navBusinessHighlighter')
    }

    if (Common.resize) {
      Common.resize.addHandler(() => this._updatePos(), 'navBusinessHighlighter')
    }
  }

  _removeHandlers() {
    Common.raf?.removeHandler('navBusinessHighlighter')
    Common.resize?.removeHandler('navBusinessHighlighter')
  }

  onRaf() {
    const scrollY = Common.scroll.currentScroll
    const len = this.sectionInfo.length

    // 0. 最初のセクションに達する前 → 最初のリストをカレントに
    if (scrollY < this.sectionInfo[0].top) {
      if (this.currentKey !== this.sectionInfo[0].key) {
        this._setCurrent(this.sectionInfo[0].key)
      }
      return
    }

    // 1. 通常のセクション内にいる場合
    for (let i = 0; i < len; i++) {
      const info = this.sectionInfo[i]
      const nextInfo = this.sectionInfo[i + 1]

      const start = info.top
      const end = nextInfo ? nextInfo.top : Infinity

      if (scrollY >= start && scrollY < end) {
        if (this.currentKey !== info.key) {
          this._setCurrent(info.key)
        }
        return
      }
    }

    // 2. 最後のセクションを過ぎた後 → 最後のリストをカレントに
    const last = this.sectionInfo[len - 1]
    if (this.currentKey !== last.key) {
      this._setCurrent(last.key)
    }
  }

  _setCurrent(key) {
    this.currentKey = key

    this.sectionInfo.forEach((info) => {
      if (!info.$item) return

      if (info.key === key) {
        info.$item.classList.add(this.classNames.current)
      } else {
        info.$item.classList.remove(this.classNames.current)
      }
    })
  }
}